import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ProvedorSessao } from './sessao.jsx'
import App from './App.jsx'
import './estilos.css'

// Tema escolhido pelo usuário; sem escolha, segue o sistema operacional.
const temaSalvo = localStorage.getItem('tema')
if (temaSalvo && temaSalvo !== 'sistema') document.documentElement.dataset.tema = temaSalvo

createRoot(document.getElementById('raiz')).render(
  <StrictMode>
    <BrowserRouter>
      <ProvedorSessao>
        <App />
      </ProvedorSessao>
    </BrowserRouter>
  </StrictMode>,
)
